<template>
<div class="emergencyManage clearfix">

   <event-category></event-category>

   <scenic-statistics></scenic-statistics>
   <plan-start></plan-start>
   <!-- <china></china> -->
   <emergency-event></emergency-event>
   <event-level></event-level>
  <business></business>

</div>
</template>

<script>
import scenicStatistics from './scenicStatistics'
import china from '../China/index.vue'
import business from './business'
import eventCategory from './eventCategory'
import eventLevel from './eventLevel'
import planStart from './planStart'
import emergencyEvent from './emergencyEvent'
export default{
    name:'emergencyManage',
    data(){
        return{

        }
    },
   components:{
        business,
        china,
        'scenic-statistics':scenicStatistics,
        'event-category':eventCategory,
        'event-level':eventLevel,
        'plan-start':planStart,
        'emergency-event':emergencyEvent
  }
}

</script>

<style >
.w326{
  height: 45vh!important;
  width: 32.5%!important;
  margin-left: 0.8%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/emergencyManage/emergencyManage.vue